import { loadScriptOnce } from '../utils/dom';

export function initIubenda(): void {
  window.addEventListener(
    'load',
    () => loadScriptOnce('https://cdn.iubenda.com/iubenda.js'),
    { once: true }
  );
}
